import React from "react";
import { Outlet } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Nav />
      <main className="flex-1 pt-[72px]">
        <Outlet />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
}
